module.exports = __webpack_public_path__ + "assets/img/NVIDIA-1d0aae2a.png";